/**
 * Ad Broadcast Service API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
 

export enum BroadcastStatus {

      NotStarted = 0,
      Processing = 1,
      Completed = 2,
      Failed = 3,
      Error = 4,
      Deprecated = 5,

};
